import gql from 'graphql-tag'
import { DataProxy } from '~/node_modules/apollo-cache/src/types/DataProxy'
import {
  GQLSuggestFragments,
  GQLSuggestFragmentsArg,
} from '~/graphql/gqlLocal/localSuggestFragments.types'

export const GET_LOCAL_SUGGEST_FRAGMENTS = gql`
  query {
    suggestFragments @client
  }
`

export const DELETE_ALL_LOCAL_SUGGEST_FRAGMENTS = gql`
  mutation {
    deleteAllFragments @client
  }
`

export const DELETE_LOCAL_SUGGEST_FRAGMENT = gql`
  mutation($fragment: String!) {
    deleteFragment(fragment: $fragment) @client
  }
`

export const ADD_LOCAL_SUGGEST_FRAGMENT = gql`
  mutation($fragment: String!) {
    addFragment(fragment: $fragment) @client
  }
`

const syncLocalStorage = (fragments: string[]) => {
  const sanitizedFragments = fragments.map((fragment) =>
    fragment.replace(/,/g, '')
  )

  window.localStorage.setItem('suggestFragments', sanitizedFragments.join(','))
}

export const mutationSuggestFragments = {
  addFragment: (
    _: {},
    args: { fragment: string },
    { cache }: { cache: DataProxy }
  ) => {
    const queryResult: GQLSuggestFragments | null = cache.readQuery({
      query: GET_LOCAL_SUGGEST_FRAGMENTS,
    })
    const suggestFragments = queryResult?.suggestFragments ?? []

    if (suggestFragments.includes(args.fragment)) {
      return
    }

    const mergedFragments = [...suggestFragments, args.fragment]

    syncLocalStorage(mergedFragments)

    cache.writeData({
      data: {
        suggestFragments: mergedFragments,
      },
    })
  },
  deleteAllFragments: (
    _: {},
    _args: GQLSuggestFragmentsArg,
    { cache }: { cache: DataProxy }
  ) => {
    syncLocalStorage([])

    cache.writeData({
      data: {
        suggestFragments: [],
      },
    })
  },
  deleteFragment: (
    _: {},
    args: GQLSuggestFragmentsArg,
    { cache }: { cache: DataProxy }
  ) => {
    const queryResult: GQLSuggestFragments | null = cache.readQuery({
      query: GET_LOCAL_SUGGEST_FRAGMENTS,
    })
    const suggestFragments = queryResult?.suggestFragments ?? []
    const filteredFragments = suggestFragments.filter(
      (frag: string) => args.fragment !== frag
    )

    syncLocalStorage(filteredFragments)

    cache.writeData({
      data: {
        suggestFragments: filteredFragments,
      },
    })
  },
}

export const getSuggestFragmentsFromStorage = () => {
  if (process.client) {
    const fragmentString = window.localStorage.getItem('suggestFragments') || ''
    if (fragmentString) {
      return fragmentString.split(',')
    }
  }

  return []
}
